import OrderedList from '@tiptap/extension-ordered-list'

/**
 * Ordered list with HTML type attribute so we can use numbers (1) or letters (a).
 */
export const TypedOrderedList = OrderedList.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      type: {
        default: '1',
        parseHTML: (element) => element.getAttribute('type') || '1',
        renderHTML: (attributes) => {
          if (!attributes.type || attributes.type === '1') {
            return { type: '1' }
          }
          return { type: attributes.type }
        },
      },
    }
  },
})

export function isNumberedListActive(editor) {
  if (!editor?.isActive('orderedList')) return false
  const type = editor.getAttributes('orderedList').type
  return !type || type === '1'
}

export function isLetteredListActive(editor) {
  if (!editor?.isActive('orderedList')) return false
  return editor.getAttributes('orderedList').type === 'a'
}

export function toggleBulletList(editor) {
  if (!editor) return
  editor.chain().focus().toggleBulletList().run()
}

export function toggleNumberedList(editor) {
  if (!editor) return
  if (isNumberedListActive(editor)) {
    editor.chain().focus().toggleOrderedList().run()
    return
  }
  if (editor.isActive('orderedList')) {
    editor.chain().focus().updateAttributes('orderedList', { type: '1' }).run()
    return
  }
  editor
    .chain()
    .focus()
    .toggleOrderedList()
    .updateAttributes('orderedList', { type: '1' })
    .run()
}

export function toggleLetteredList(editor) {
  if (!editor) return
  if (isLetteredListActive(editor)) {
    editor.chain().focus().toggleOrderedList().run()
    return
  }
  if (editor.isActive('orderedList')) {
    editor.chain().focus().updateAttributes('orderedList', { type: 'a' }).run()
    return
  }
  editor
    .chain()
    .focus()
    .toggleOrderedList()
    .updateAttributes('orderedList', { type: 'a' })
    .run()
}
